import { Editor } from '@tinymce/tinymce-react';
import formStyle from '../style/WForm.less';
import { i18nLang } from '../../../i18n/i18nLang';
import * as React from 'react';

interface WFormFieldRichTextProps extends React.ClassAttributes<any> {
    label: JSX.Element;
    name: string;
    value: string;
    readonly?: boolean;
    height?: string;
    module?: string;
    editorInitConfig?: any
    onValueChange(name: string, value: any): void;
}

interface WFormFieldRichTextState extends React.ClassAttributes<any> {
    data: string;
}

export class WFormFieldRichText extends React.Component<WFormFieldRichTextProps, WFormFieldRichTextState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: this.props.value ? this.props.value : ''
        };
        this.onHandleChange = this.onHandleChange.bind(this);
    }

    onHandleChange(data: any, editor: any): void {
        this.setState({ data });
        this.props.onValueChange(this.props.name, data);
    }

    render(): JSX.Element {
        const { editorInitConfig } = this.props;

        const baseOptions = {
            plugins: [
                'code',
                'advlist autolink lists link image charmap',
                'searchreplace',
                'table paste imagetools'
            ],
            toolbar: 'imgButton | undo redo | bold italic underline |' +
                ' fontselect fontsizeselect | forecolor backcolor |' +
                ' styleselect | outdent indent |' +
                ' alignleft aligncenter alignright alignjustify |' +
                ' numlist bullist | table | charmap | image | superscript subscript | code'
        };

        const minimalOptions = {
            plugins: [
                'code',
                'advlist autolink link image charmap',
                'searchreplace',
                'paste imagetools'
            ],
            toolbar: 'imgButton | undo redo | bold italic underline |' +
                ' fontsizeselect styleselect outdent indent |' +
                ' alignleft aligncenter alignright alignjustify |' +
                ' charmap |image | superscript subscript | code'
        };

        const style_formats = [
            {
                title: 'Breite', items: [
                    { title: '300 px', block: 'p', styles: { width: '300px' } },
                    { title: '400 px', block: 'p', styles: { width: '400px' } },
                    { title: '500 px', block: 'p', styles: { width: '500px' } },
                    { title: '600 px', block: 'p', styles: { width: '600px' } },
                    { title: '700 px', block: 'p', styles: { width: '700px' } }
                ]
            }
        ];

        const init = {
            language: i18nLang.getUILang(),
            menubar: 'edit',
            plugins: this.props.module === 'wips' ? minimalOptions.plugins : baseOptions.plugins,
            toolbar: this.props.module === 'wips' ? minimalOptions.toolbar : baseOptions.toolbar,
            fontsize_formats: '8pt 9pt 10pt 11pt 12pt 13pt 14pt 18pt 20pt 24pt 30pt 36pt',
            charmap_append: [
                [0x2082, '2']
            ],
            image_advtab: true,
            images_upload_handler: function (blobInfo: any, success: any, failure: any) {
                const blobURL = URL.createObjectURL(blobInfo.blob());
                const type = blobInfo.blob().type;
                const xhr = new XMLHttpRequest();
                xhr.open('get', blobURL);
                xhr.overrideMimeType('text/plain; charset=x-user-defined');
                xhr.onload = function () {
                    success('data:' + type + ';base64,' + blobInfo.base64());
                };
                xhr.send();
            },
            // resize: 'both',
            width: '100%',
            entity_encoding: 'raw',
            height: this.props.height ? this.props.height : 420,
            content_style: 'a { color: #6692c3; }',
            style_formats,
            style_formats_merge: true
        };

        return (
            <div className={formStyle.fieldBox}>
                {this.props.label}
                <div
                    className={formStyle.input}
                    style={{
                        zIndex: 0,
                        marginTop: 5,
                        width: '100%',
                        minHeight: this.props.height ? this.props.height : 300
                    }}
                >
                    <Editor
                        onInit={(event: any, ref: any) => ref ? ref.focus() : null}
                        // apiKey='b47mm5vf1055739xetkoophwqb0am3a77hpn2z7negwz6yyk'
                        apiKey='eorig5s36njozn0k9dossy9dn2xo329s8t1ltmkid816xxzj'
                        value={this.state.data}
                        init={{
                            ...init,
                            ...(editorInitConfig || {})
                        }}
                        onEditorChange={this.onHandleChange}
                    />
                </div>
            </div>
        );
    }
}
